import { trackSelfDescribingEvent } from "@snowplow/browser-tracker";

import { RecommenderRequestContext } from "../types";

export function emitRecommenderRequest({
  source_type,
  pre_hydration_product_count = null,
  post_hydration_product_count = null,
  hydration_error_count = null,
  from_product_ids = null,
  from_product_offer_id = null,
  from_product_displayed_price = null,
  rec_version = 0,
  cold_start_version = null,
  page_limit = null,
  page_offset = null,
}: RecommenderRequestContext["options"]) {
  trackSelfDescribingEvent({
    event: {
      schema: "iglu:au.com.catch/recommender_request/jsonschema/1-0-3",
      data: {
        source_type: source_type,
        pre_hydration_product_count,
        post_hydration_product_count,
        hydration_error_count,
        from_product_ids,
        from_product_offer_id,
        from_product_displayed_price,
        rec_version,
        cold_start_version,
        page_limit,
        page_offset,
      },
    },
  });
}
